import { ActiveState, EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { SetupParameterKindListViewModel } from 'chronos-basedata-client';
import { Filters } from './setup-parameter.model';

export interface SetupParameterState extends EntityState<SetupParameterKindListViewModel>, ActiveState {
  filters: Filters;
}

const initialState = {
  filters: {
    externalSetupParameterKindId: ''
  }
};

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'setupParameter', idKey: 'setupParameterKindId' })
export class SetupParameterStore extends EntityStore<SetupParameterState, SetupParameterKindListViewModel> {
  constructor() {
    super(initialState);
  }

  public updateFilters(filters: Filters): void {
    this.update({ filters });
  }

  public resetFilters(): void {
    this.update(initialState);
  }
}
